// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.income-tag[data-v-48a3c3c8] {\n  width: 140px;\n}\n.field-separation[data-v-48a3c3c8] {\n  padding: 1rem 0;\n}\n.text-center[data-v-48a3c3c8] {\n  text-align: center;\n}\n.text-left[data-v-48a3c3c8]{\n  text-align: left;\n}\n@media screen and (min-width: 992px) {\n.field[data-v-48a3c3c8] {\n    margin-bottom: 0 !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
